import React from "react";
import "./NotFound.css";
import { useNavigate } from "react-router-dom";
import PageWrapper from "../../pages/SignupPages/PageWrapper";
const NotFound: React.FC = () => {
  const navigate = useNavigate();
  const handleNext = () => {
    navigate("/");
  };
  return (
    <PageWrapper>
      <div className="not-found-container">
        <h1>404</h1>
        <p className="oops">Oops, This Page Could Not Be Found.</p>
        <p className="not-found-content">
          The page you are looking for might have been removed, had its name
          changed, or is temporarily unavailable.
        </p>
        <button onClick={handleNext} className="next-btn">
          Back to Home
        </button>
      </div>
    </PageWrapper>
  );
};

export default NotFound;
